import {Component} from '@angular/core';
import {SessionService} from '../../../core/security';

@Component({
    selector: 'bs-top-bar',
    template: require('./top.bar.template.html')
})
export class TopBarComponent {

    constructor(private _sessionService: SessionService) {
    }

    logout() {
        this._sessionService.logout();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/space/top_bar/top.bar.component.ts